// Dados oficiais da Muita Mídia LTDA — fonte única de verdade para todo o site.

export const company = {
  legalName: 'Muita Mídia LTDA',
  brandName: 'Muita Mídia',
  cnpj: '51.781.940/0001-04',
  cnpjDigits: '51781940000104',
  address: 'Avenida Afonso Pena, 3355, Sala 1101, Bairro Serra, Belo Horizonte/MG, CEP 30130-008',
  addressShort: 'Av. Afonso Pena, 3355, Sala 1101, Serra, Belo Horizonte/MG, CEP 30130-008',
  city: 'Belo Horizonte',
  state: 'MG',
  postalCode: '30130-008',
  website: 'https://www.muitamidiaofc.com.br/',
  foundedYear: 2019,
  clientsServed: '7.000',
  pagesSold: '8.400',
  minFollowers: '1 mil',
  maxFollowers: '900 mil',
  whatsappNumber: '5531983316620',
}

export function whatsappLink(message: string): string {
  return `https://wa.me/${company.whatsappNumber}?text=${encodeURIComponent(message)}`
}

export function breadcrumbSchema(items: { name: string, path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `https://www.muitamidiaofc.com.br${item.path}`,
    })),
  }
}

export const whatsappMessages = {
  heroCta: 'Olá! Vim pelo site e quero comprar uma página do Instagram com a Muita Mídia. Podem me ajudar a escolher o nicho e a faixa de seguidores?',
  finalCta: 'Olá! Quero saber mais sobre como comprar uma página do Instagram com a Muita Mídia.',
  servicesCta: 'Olá! Vi os serviços da Muita Mídia no site e quero saber mais detalhes.',
  howItWorksCta: 'Olá! Li o passo a passo no site e quero iniciar a compra da minha página do Instagram.',
  contactCta: 'Olá! Estou no site da Muita Mídia e gostaria de falar com um consultor.',
  consultingCta: 'Olá! Quero uma consultoria para escolher o nicho e o tamanho ideal de página do Instagram para o meu objetivo.',
  serviceCta: (serviceName: string) =>
    `Olá! Quero saber mais sobre o serviço "${serviceName}" da Muita Mídia.`,
  blogCta: 'Olá! Li um artigo no blog da Muita Mídia e quero saber mais sobre como comprar uma página do Instagram.',
  headerCta: 'Olá! Quero falar com a Muita Mídia sobre comprar uma página do Instagram.',
}

export const navLinks = [
  { label: 'Início', to: '/' },
  { label: 'Serviços', to: '/servicos' },
  { label: 'Como Funciona', to: '/como-funciona' },
  { label: 'Blog', to: '/blog' },
  { label: 'Sobre', to: '/sobre' },
  { label: 'Contato', to: '/contato' },
]

export const footerPolicyLinks = [
  { label: 'Política de Privacidade', to: '/politica-de-privacidade' },
  { label: 'Termos de Uso', to: '/termos-de-uso' },
  { label: 'Política de Garantia', to: '/politica-de-garantia' },
]

export const stats = [
  { value: '+8.400', label: 'páginas vendidas' },
  { value: '+7.000', label: 'clientes atendidos' },
  { value: '2019', label: 'no mercado desde' },
  { value: '1k–900k', label: 'seguidores por página' },
]

export const reasonsToBuy = [
  {
    icon: 'TrendingDown',
    title: 'O alcance orgânico está em queda',
    description:
      'Criar uma página do zero hoje significa competir contra um algoritmo que entrega cada vez menos alcance para perfis novos. Uma página já estabelecida chega até você com histórico e audiência formados.',
  },
  {
    icon: 'Clock',
    title: 'Anos de trabalho, resolvidos em minutos',
    description:
      'Crescer uma conta do Instagram do zero costuma levar de 1 a 3 anos de publicação constante. Ao comprar uma página, você recebe esse tempo de volta e começa a operar imediatamente.',
  },
  {
    icon: 'CircleDollarSign',
    title: 'Menos gasto com anúncios para crescer',
    description:
      'Impulsionar uma conta nova do zero exige investimento contínuo em tráfego pago. Uma página com audiência real já formada reduz a dependência de anúncios para gerar alcance inicial.',
  },
]

export const whatYouGet = [
  {
    icon: 'KeyRound',
    title: 'Login e senha de acesso',
    description: 'Você recebe as credenciais completas da página imediatamente após a confirmação do pagamento.',
  },
  {
    icon: 'Mail',
    title: 'E-mail vinculado à conta',
    description: 'O e-mail associado ao perfil é entregue junto, para que você tenha controle total desde o início.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Transferência assistida e segura',
    description: 'Acompanhamos a troca de e-mail, senha, autenticação em dois fatores (2FA) e a verificação de propriedade.',
  },
  {
    icon: 'Headset',
    title: 'Suporte pós-venda pelo WhatsApp',
    description: 'Orientação contínua para configurar o perfil e dar os primeiros passos com segurança.',
  },
  {
    icon: 'BadgeCheck',
    title: 'Garantia de 7 dias',
    description: 'Reembolso integral em até 7 dias, conforme o Código de Defesa do Consumidor, se o perfil permanecer nas condições de entrega.',
  },
]

export interface ServiceItem {
  slug: string
  icon: string
  title: string
  shortDescription: string
  longDescription: string
  bullets: string[]
}

export const services: ServiceItem[] = [
  {
    slug: 'venda-de-paginas-nichadas',
    icon: 'Instagram',
    title: 'Venda de páginas nichadas do Instagram',
    shortDescription: 'Páginas de 1 mil a 900 mil seguidores, organizadas por nicho e faixa de audiência.',
    longDescription:
      'Trabalhamos com um portfólio de páginas do Instagram já formadas em diversos nichos, com faixas de seguidores que vão de 1 mil a 900 mil. Você escolhe o segmento e o tamanho de audiência mais adequado ao seu objetivo — pessoal, comercial ou para revenda de conteúdo — e recebe uma conta pronta para publicar, sem precisar começar do zero.',
    bullets: [
      'Páginas de 1k a 900k seguidores',
      'Diversos nichos disponíveis (moda, humor, pets, motivação, viagens, entre outros)',
      'Seguidores 100% reais e orgânicos, sem bots ou automações',
      'Curadoria constante do portfólio de páginas disponíveis',
    ],
  },
  {
    slug: 'verificacao-manual-e-curadoria',
    icon: 'ShieldCheck',
    title: 'Verificação manual e curadoria de páginas',
    shortDescription: 'Cada página é avaliada manualmente antes de entrar no nosso portfólio de vendas.',
    longDescription:
      'Antes de qualquer página chegar até você, ela passa por uma verificação manual completa. Analisamos o histórico de conteúdo, o comportamento do engajamento, a conformidade com as políticas da Meta e a ausência de restrições como shadowban, banimentos parciais ou violações registradas. Só entram no nosso portfólio as páginas aprovadas nesse processo.',
    bullets: [
      'Compliance com as políticas da Meta/Instagram',
      'Verificação de ausência de shadowban',
      'Análise do histórico de conteúdo e integridade da conta',
      'Somente páginas sem violações ou restrições ativas',
    ],
  },
  {
    slug: 'transferencia-assistida-e-segura',
    icon: 'RefreshCcw',
    title: 'Transferência assistida e segura',
    shortDescription: 'Acompanhamos toda a troca de e-mail, senha, 2FA e verificação de propriedade.',
    longDescription:
      'A transferência de uma página do Instagram envolve etapas sensíveis de segurança. Por isso, orientamos você em cada uma delas: a troca do e-mail vinculado, a definição de uma nova senha, a ativação da autenticação em dois fatores (2FA) e a verificação de propriedade da conta. O objetivo é que, em poucos minutos, o perfil esteja 100% sob o seu controle.',
    bullets: [
      'Troca assistida de e-mail e senha',
      'Configuração de autenticação em dois fatores (2FA)',
      'Verificação de propriedade da conta',
      'Passo a passo acompanhado do início ao fim',
    ],
  },
  {
    slug: 'suporte-pos-venda-e-orientacao',
    icon: 'Headset',
    title: 'Suporte pós-venda e orientação estratégica',
    shortDescription: 'Ajudamos você a configurar o perfil e a dar os primeiros passos de publicação.',
    longDescription:
      'A relação com a Muita Mídia não termina na entrega. Depois da transferência, oferecemos suporte pelo WhatsApp para dúvidas técnicas sobre acesso, senha e e-mail vinculado, além de orientações estratégicas para você começar a publicar com consistência e manter a saúde da conta recém-adquirida.',
    bullets: [
      'Suporte técnico via WhatsApp após a compra',
      'Orientação para configuração inicial do perfil',
      'Sugestões estratégicas para os primeiros conteúdos',
      'Acompanhamento contínuo em caso de dúvidas',
    ],
  },
  {
    slug: 'consultoria-de-nicho-e-tamanho',
    icon: 'Compass',
    title: 'Consultoria para escolha de nicho e tamanho ideal',
    shortDescription: 'Ajudamos a definir qual página faz mais sentido para o seu objetivo.',
    longDescription:
      'Nem toda página serve para todo objetivo. Antes da compra, conversamos com você para entender se o foco é construir autoridade pessoal, revender produtos, alavancar um negócio local ou iniciar um projeto de conteúdo — e recomendamos o nicho e a faixa de seguidores mais coerentes com essa meta, evitando compras que não vão gerar o resultado esperado.',
    bullets: [
      'Diagnóstico do objetivo antes da recomendação',
      'Indicação de nicho compatível com o seu mercado',
      'Orientação sobre a faixa de seguidores ideal',
      'Conversa 100% pelo WhatsApp, sem compromisso',
    ],
  },
]

export const howToSteps = [
  {
    title: 'Contato pelo WhatsApp',
    description: 'Você fala com a nossa equipe pelo botão do WhatsApp e explica o que procura: nicho, objetivo e faixa de seguidores desejada.',
  },
  {
    title: 'Escolha do nicho e da faixa de seguidores',
    description: 'Apresentamos as opções disponíveis no portfólio, de 1 mil a 900 mil seguidores, dentro do segmento que você procura.',
  },
  {
    title: 'Pagamento via Pix ou cartão em até 12x',
    description: 'Você escolhe entre Pix, com desconto e confirmação instantânea, ou cartão de crédito parcelado em até 12x (juros do link pagos pelo cliente).',
  },
  {
    title: 'Entrega imediata pelo WhatsApp',
    description: 'Assim que o pagamento é confirmado, você recebe login, senha e e-mail vinculado diretamente no WhatsApp.',
  },
  {
    title: 'Transferência assistida',
    description: 'Acompanhamos a troca de e-mail, senha, 2FA e a verificação de propriedade, até você ter controle total do perfil.',
  },
  {
    title: 'Suporte contínuo',
    description: 'Depois da transferência, seguimos disponíveis pelo WhatsApp para dúvidas técnicas e orientação estratégica de publicação.',
  },
]

export const verificationChecklist = [
  'Conformidade com as políticas da Meta e do Instagram',
  'Ausência de shadowban ou limitação de alcance',
  'Histórico de conteúdo e integridade da conta',
  'Ausência de violações, denúncias ou restrições registradas',
  'Autenticidade e origem orgânica dos seguidores',
  'Propriedade da conta assumida diretamente pela Muita Mídia',
]

export interface ComparisonRow {
  feature: string
  muitaMidia: string
  sellerWithoutCompany: string
  fakeFollowers: string
}

export const comparisonRows: ComparisonRow[] = [
  { feature: 'Empresa registrada e com CNPJ', muitaMidia: 'Sim, desde 2019', sellerWithoutCompany: 'Raramente', fakeFollowers: 'Não se aplica' },
  { feature: 'Verificação manual da página', muitaMidia: 'Em todas as páginas', sellerWithoutCompany: 'Não há garantia', fakeFollowers: 'Não há verificação' },
  { feature: 'Seguidores reais e orgânicos', muitaMidia: 'Sim, 100%', sellerWithoutCompany: 'Não é possível confirmar', fakeFollowers: 'Não, seguidores falsos' },
  { feature: 'Risco de shadowban ou banimento', muitaMidia: 'Reduzido pela curadoria', sellerWithoutCompany: 'Alto e desconhecido', fakeFollowers: 'Muito alto' },
  { feature: 'Transferência assistida', muitaMidia: 'Sim, passo a passo', sellerWithoutCompany: 'Por conta própria', fakeFollowers: 'Não se aplica' },
  { feature: 'Garantia de 7 dias (CDC)', muitaMidia: 'Sim, formalizada', sellerWithoutCompany: 'Sem garantia', fakeFollowers: 'Sem garantia' },
  { feature: 'Suporte pós-venda', muitaMidia: 'Pelo WhatsApp', sellerWithoutCompany: 'Geralmente inexistente', fakeFollowers: 'Inexistente' },
]

export interface Testimonial {
  name: string
  role: string
  quote: string
  rating: number
}

export const testimonials: Testimonial[] = [
  {
    name: 'Camila R.',
    role: 'Nicho de moda feminina',
    quote: 'Eu já tinha tentado crescer uma página do zero por mais de um ano sem sair do lugar. Com a página que comprei da Muita Mídia, comecei a vender já na primeira semana. A transferência foi acompanhada do início ao fim, sem sustos.',
    rating: 5,
  },
  {
    name: 'Diego A.',
    role: 'Nicho de humor',
    quote: 'O que mais me deixou seguro foi a verificação antes da compra. Perguntei sobre shadowban e violações, e a equipe explicou todo o histórico da página antes de eu pagar qualquer coisa.',
    rating: 5,
  },
  {
    name: 'Fernanda M.',
    role: 'Nicho pet',
    quote: 'Paguei via Pix e recebi acesso em poucos minutos pelo WhatsApp. O suporte me ajudou a trocar e-mail, senha e ativar o 2FA sem eu entender nada de tecnologia antes.',
    rating: 5,
  },
  {
    name: 'Rodrigo S.',
    role: 'Revenda de produtos',
    quote: 'Pesquisei bastante antes de decidir onde comprar página do Instagram. A diferença de comprar com uma empresa registrada, com CNPJ e garantia formal, é muito grande em relação a perfis de vendedores individuais.',
    rating: 5,
  },
]

export interface FaqItem {
  question: string
  answer: string
  badges: string[]
}

export const faqs: FaqItem[] = [
  {
    question: 'Como eu recebo o acesso do perfil?',
    answer:
      'Você recebe tudo pelo WhatsApp! A entrega é feita imediatamente após o pagamento ser confirmado. Você receberá: login e senha de acesso, e-mail vinculado à conta e orientações completas para a transferência segura. Acompanhamos todo o passo a passo para garantir que a transferência ocorra com total segurança e você tenha controle completo do perfil.',
    badges: ['⚡ Entrega imediata', '🔐 Acesso completo'],
  },
  {
    question: 'Quais formas de pagamento vocês aceitam?',
    answer:
      'Operamos com pagamentos via Pix e cartão de crédito. 💰 Pix (recomendado): garante descontos especiais e pagamento à vista com confirmação instantânea. 💳 Cartão de crédito: parcele em até 12x, com juros do link de pagamento sendo pagos pelo cliente.',
    badges: ['⚡ Aprovação rápida', '🔒 Pagamento seguro'],
  },
  {
    question: 'Os perfis possuem violações?',
    answer:
      'Não! Todos os perfis são avaliados manualmente por nós antes de chegar até você. Não compramos qualquer página — somente páginas que estão em dia com as políticas da plataforma (diretrizes da Meta/Instagram) e sem histórico de violações ou restrições. Nossa verificação inclui: compliance com políticas, ausência de shadowban, histórico de conteúdo e integridade da conta.',
    badges: ['✅ Verificação manual', '🛡️ Sem violações', '✓ Conforme políticas Meta'],
  },
  {
    question: 'Os seguidores são reais?',
    answer:
      'Sim, 100% reais! Vendemos apenas páginas com seguidores reais e orgânicos — páginas que cresceram organicamente no Instagram. Nada de: bots, automações, compra de seguidores, seguidores falsos ou engajamento inflado artificialmente. Você recebe uma base autêntica, construída de forma natural, com pessoas reais que seguem o nicho da página. Pronta para você continuar publicando e desenvolvendo seu projeto.',
    badges: ['👥 Seguidores reais', '🌱 Crescimento orgânico', '🚫 Zero automação'],
  },
  {
    question: 'Qual a garantia que tenho?',
    answer:
      '✅ Todas as páginas possuem garantia de 7 dias, conforme previsto na lei brasileira (Código de Defesa do Consumidor). Você pode solicitar o reembolso integral do valor da página dentro desse prazo, desde que a página esteja nas mesmas condições em que foi entregue a você. ⚠️ Atenção importante: após alterações no perfil (mudança de @, nome, foto, bio, etc.), a compra não pode ser desfeita. A garantia de 7 dias é válida apenas se o perfil permanecer nas condições originais de entrega.',
    badges: ['📅 Garantia de 7 dias', '⚖️ Base no CDC'],
  },
  {
    question: 'Quanto tempo leva o processo de transferência?',
    answer:
      'O processo é super rápido! Após a confirmação do pagamento, você recebe o acesso imediatamente pelo WhatsApp. Orientamos o passo a passo completo para a transferência segura: mudança de e-mail, senha, autenticação em dois fatores e verificação de propriedade. Geralmente, em poucos minutos você já está com o perfil totalmente sob seu controle, pronto para começar a publicar.',
    badges: ['⚡ Acesso imediato', '📋 Passo a passo completo'],
  },
  {
    question: 'Vocês dão suporte após a compra?',
    answer:
      'Com certeza! Oferecemos suporte completo após a compra pelo WhatsApp. Nosso suporte inclui: orientação completa sobre transferência e configuração do perfil; dúvidas técnicas sobre acesso, senha e e-mail vinculado; sugestões estratégicas para começar a publicar com consistência. Estamos aqui para que você comece a trabalhar com segurança e confiança.',
    badges: ['💬 Suporte via WhatsApp', '🤝 Acompanhamento completo'],
  },
  {
    question: 'A Muita Mídia é dona de todas as páginas?',
    answer:
      'Sim! Todas as páginas já estão conectadas em nossos computadores, garantindo acesso seguro e imediato para você. Por que isso importa: transferência 100% segura e acompanhada por nós; orientação completa em toda a transição (mudança de e-mail, senha, 2FA); você recebe acesso validado e testado antes da compra. Não revendemos páginas de terceiros sem controle. Cada perfil está sob nossa propriedade e gestão direta até a transferência completa para você.',
    badges: ['🏢 Propriedade verificada', '🔐 Acesso seguro', '✓ Gestão direta'],
  },
]

export interface BlogSection {
  heading?: string
  paragraphs: string[]
  list?: string[]
}

export interface BlogPostData {
  slug: string
  title: string
  excerpt: string
  readTime: string
  publishedAt: string
  sections: BlogSection[]
}

export const blogPosts: BlogPostData[] = [
  {
    slug: 'onde-comprar-pagina-do-instagram-o-que-avaliar',
    title: 'Onde comprar página do Instagram: o que avaliar antes de decidir',
    excerpt: 'Antes de escolher onde comprar página do Instagram, existem critérios objetivos que separam uma compra segura de um prejuízo. Veja o que analisar.',
    readTime: '6 min de leitura',
    publishedAt: '2024-02-12',
    sections: [
      {
        paragraphs: [
          'Comprar uma página do Instagram pode ser a forma mais rápida de sair do zero e começar a operar com audiência real. Mas a pergunta que decide se essa compra vai ser um bom negócio não é apenas "quanto custa", e sim "onde comprar página do Instagram com segurança". Existem critérios concretos que ajudam a separar uma negociação confiável de um risco desnecessário.',
        ],
      },
      {
        heading: '1. A empresa é registrada e tem CNPJ?',
        paragraphs: [
          'O primeiro filtro é simples: quem está vendendo a página é uma empresa formalmente registrada ou uma pessoa física sem qualquer vínculo comercial? Empresas com CNPJ ativo, como a Muita Mídia LTDA (CNPJ 51.781.940/0001-04), respondem legalmente pela venda, emitem comprovantes e podem ser localizadas em caso de problema. Perfis anônimos em redes sociais ou grupos de mensagens não oferecem esse tipo de garantia.',
        ],
      },
      {
        heading: '2. A página passa por verificação manual antes da venda?',
        paragraphs: [
          'Uma página pode parecer saudável à primeira vista e, ainda assim, ter um histórico de shadowban, violações às políticas da Meta ou restrições de alcance. Por isso, antes de comprar, pergunte se existe um processo de verificação manual: análise do histórico de conteúdo, checagem de conformidade com as políticas da plataforma e confirmação da ausência de banimentos parciais.',
        ],
        list: [
          'Compliance com as políticas da Meta/Instagram',
          'Histórico de conteúdo e integridade da conta',
          'Ausência de shadowban ou restrições ativas',
        ],
      },
      {
        heading: '3. Os seguidores são reais e orgânicos?',
        paragraphs: [
          'Uma página com números altos, mas seguidores comprados ou inflados artificialmente, tende a ter baixo engajamento real e alto risco de penalização pela plataforma. Antes de decidir onde comprar página do Instagram, confirme que a base de seguidores é composta por contas reais, formadas por crescimento orgânico — e não por bots ou automações.',
        ],
      },
      {
        heading: '4. Como funciona a transferência de propriedade?',
        paragraphs: [
          'A troca de titularidade de uma conta envolve etapas sensíveis: alteração de e-mail vinculado, definição de nova senha, ativação de autenticação em dois fatores e verificação de propriedade. Fornecedores sérios acompanham esse processo com você, em vez de simplesmente entregar uma senha e desaparecer.',
        ],
      },
      {
        heading: '5. Existe garantia formal pós-compra?',
        paragraphs: [
          'No Brasil, o Código de Defesa do Consumidor prevê prazo de garantia para produtos e serviços. Empresas que vendem página do Instagram com seriedade costumam formalizar uma garantia de 7 dias, válida enquanto o perfil permanece nas condições originais de entrega — sem alterações de usuário, nome, foto ou biografia.',
        ],
      },
      {
        heading: 'Como a Muita Mídia atende a esses critérios',
        paragraphs: [
          'A Muita Mídia é uma empresa registrada desde 2019, especializada na venda de páginas nichadas do Instagram de 1 mil a 900 mil seguidores. Já atendemos mais de 7.000 clientes e vendemos mais de 8.400 páginas, sempre com verificação manual, seguidores reais, transferência assistida e garantia de 7 dias. Todo o atendimento é feito pelo WhatsApp, com entrega imediata após a confirmação do pagamento.',
        ],
      },
    ],
  },
  {
    slug: 'pagina-barata-demais-sinais-de-alerta',
    title: 'Página barata demais: sinais de alerta antes de fechar negócio',
    excerpt: 'Um preço muito abaixo do mercado costuma esconder um problema. Conheça os sinais de alerta ao avaliar uma página do Instagram "barata demais".',
    readTime: '5 min de leitura',
    publishedAt: '2024-03-05',
    sections: [
      {
        paragraphs: [
          'É natural buscar comprar página instagram barato. O problema é quando o preço está tão abaixo do padrão de mercado que ele deixa de ser uma vantagem e passa a ser um alerta. Uma página do Instagram tem custo de formação — tempo, conteúdo, engajamento real — e um valor muito distante disso quase sempre tem explicação.',
        ],
      },
      {
        heading: 'Sinal 1: Vendedor sem empresa ou CNPJ',
        paragraphs: [
          'Perfis que vendem por conta própria, sem qualquer estrutura formal, conseguem baixar o preço porque não emitem nota, não oferecem garantia e não têm responsabilidade legal sobre a venda. O desconto, nesse caso, é o preço da ausência de proteção para quem compra.',
        ],
      },
      {
        heading: 'Sinal 2: Nenhuma verificação da conta é mencionada',
        paragraphs: [
          'Quando o vendedor não fala em verificação manual, compliance com políticas da Meta ou histórico de shadowban, é provável que essa verificação simplesmente não exista. Isso significa que você pode estar comprando uma página com restrições ocultas, que só vão aparecer depois da transferência — quando já não há mais o que fazer.',
        ],
        list: [
          'Ausência de menção à verificação de histórico',
          'Nenhuma informação sobre shadowban ou violações',
          'Pressa em fechar o pagamento sem esclarecer dúvidas',
        ],
      },
      {
        heading: 'Sinal 3: Seguidores comprados ou engajamento artificial',
        paragraphs: [
          'Uma forma comum de reduzir custo é inflar o número de seguidores com bots e compras de seguidores falsos. O resultado é uma página com número atraente e engajamento real muito baixo, além de risco elevado de penalização pela plataforma no curto prazo.',
        ],
      },
      {
        heading: 'Sinal 4: Nenhuma garantia pós-venda',
        paragraphs: [
          'Fornecedores sérios oferecem algum tipo de garantia, ainda que dentro dos limites legais. Se o vendedor deixa claro que "não há devolução em hipótese alguma" e evita falar em prazo de garantia, isso é um indício de que ele não tem confiança na qualidade do que está vendendo.',
        ],
      },
      {
        heading: 'Sinal 5: Nenhum suporte após a entrega',
        paragraphs: [
          'Se o combinado é apenas "eu te mando a senha e acabou", não há qualquer amparo para a etapa mais delicada do processo: a transferência de e-mail, senha e autenticação em dois fatores. Sem suporte, qualquer erro nessa etapa pode custar o acesso à conta.',
        ],
      },
      {
        heading: 'Preço justo não é o mais caro, é o mais transparente',
        paragraphs: [
          'Buscar comprar página instagram barato não é um problema em si — o problema é pagar pouco por algo que não tem verificação, garantia ou suporte. Na Muita Mídia, trabalhamos com Pix com desconto especial e cartão em até 12x, sempre com verificação manual, seguidores reais, transferência assistida e garantia de 7 dias, para que o preço acessível não signifique risco.',
        ],
      },
    ],
  },
  {
    slug: 'como-funciona-a-transferencia-de-uma-pagina',
    title: 'Como funciona a transferência de uma página do Instagram',
    excerpt: 'Entenda cada etapa da transferência de propriedade de uma conta do Instagram: e-mail, senha, autenticação em dois fatores e verificação de propriedade.',
    readTime: '7 min de leitura',
    publishedAt: '2024-04-18',
    sections: [
      {
        paragraphs: [
          'A etapa mais delicada de comprar uma página do Instagram não é a escolha do nicho ou o pagamento — é a transferência de propriedade. É nesse momento que o controle da conta passa das mãos do vendedor para as suas. Entender como esse processo funciona ajuda a comprar com mais confiança.',
        ],
      },
      {
        heading: '1. Entrega inicial das credenciais',
        paragraphs: [
          'Depois da confirmação do pagamento, você recebe o login e a senha de acesso, além do e-mail vinculado à conta. Na Muita Mídia, essa entrega é feita imediatamente pelo WhatsApp, sem etapas burocráticas.',
        ],
      },
      {
        heading: '2. Troca do e-mail vinculado',
        paragraphs: [
          'O e-mail cadastrado na conta é substituído por um e-mail de sua escolha. Esse passo é essencial para que apenas você tenha capacidade de recuperar o acesso à conta em caso de necessidade futura.',
        ],
      },
      {
        heading: '3. Definição de uma nova senha',
        paragraphs: [
          'Em seguida, a senha original é substituída por uma nova senha, definida por você. A partir desse momento, o vendedor deixa de ter qualquer meio de acessar a conta.',
        ],
      },
      {
        heading: '4. Ativação da autenticação em dois fatores (2FA)',
        paragraphs: [
          'A autenticação em dois fatores adiciona uma camada extra de segurança, exigindo um código de verificação vinculado ao seu celular ou aplicativo autenticador para qualquer novo acesso à conta.',
        ],
      },
      {
        heading: '5. Verificação de propriedade',
        paragraphs: [
          'Por fim, é feita a verificação de propriedade da conta, confirmando que os dados de recuperação, e-mail e telefone vinculados pertencem a você. Esse é o passo que consolida o controle total do perfil nas suas mãos.',
        ],
        list: [
          'Troca de e-mail vinculado',
          'Definição de nova senha',
          'Ativação de autenticação em dois fatores',
          'Verificação final de propriedade',
        ],
      },
      {
        heading: 'Por que a transferência assistida faz diferença',
        paragraphs: [
          'Sem orientação, qualquer uma dessas etapas pode gerar erros que resultam em perda de acesso à conta. Por isso, na Muita Mídia, cada uma dessas etapas é acompanhada em tempo real pelo WhatsApp, do início ao fim, até você ter certeza de que o perfil está totalmente sob seu controle.',
        ],
      },
    ],
  },
  {
    slug: 'primeiros-passos-apos-comprar-sua-pagina',
    title: 'Primeiros passos após comprar sua página do Instagram',
    excerpt: 'Depois da transferência, alguns cuidados iniciais ajudam a manter a saúde da conta e a começar a publicar com estratégia.',
    readTime: '6 min de leitura',
    publishedAt: '2024-05-22',
    sections: [
      {
        paragraphs: [
          'Depois de concluir a transferência de propriedade, a página já está sob seu controle — mas o trabalho de manter e desenvolver essa conta está apenas começando. Alguns cuidados nos primeiros dias ajudam a preservar a saúde do perfil e a aproveitar melhor a audiência recebida.',
        ],
      },
      {
        heading: '1. Evite alterações bruscas nos primeiros dias',
        paragraphs: [
          'Mudanças repentinas de @usuário, nome, foto de perfil ou biografia logo após a transferência podem impactar a garantia de 7 dias e, em alguns casos, sinalizar comportamento atípico para o próprio Instagram. O recomendado é aguardar alguns dias antes de fazer ajustes de identidade visual.',
        ],
      },
      {
        heading: '2. Confirme os dados de segurança',
        paragraphs: [
          'Verifique se o e-mail vinculado, a senha e a autenticação em dois fatores foram realmente atualizados para os seus dados. Esse é o momento de garantir que nenhuma credencial antiga do vendedor ainda tenha qualquer acesso à conta.',
        ],
      },
      {
        heading: '3. Estude o nicho e o comportamento da audiência',
        paragraphs: [
          'Antes de publicar, observe o tipo de conteúdo que a página costumava veicular e como a audiência reagia a ele. Isso ajuda a manter uma transição de conteúdo mais natural, sem quebrar bruscamente as expectativas de quem já segue o perfil.',
        ],
      },
      {
        heading: '4. Publique com consistência, não com volume',
        paragraphs: [
          'Não é necessário publicar várias vezes por dia para reativar uma página. O mais importante nos primeiros momentos é manter uma frequência sustentável e coerente com o nicho, para sinalizar atividade real ao algoritmo sem parecer artificial.',
        ],
      },
      {
        heading: '5. Use o suporte pós-venda a seu favor',
        paragraphs: [
          'Se restarem dúvidas técnicas sobre acesso, segurança ou estratégia inicial de publicação, o canal de suporte da empresa vendedora deve continuar disponível. Na Muita Mídia, o suporte pós-venda pelo WhatsApp segue ativo justamente para ajudar nessa fase inicial.',
        ],
        list: [
          'Aguarde antes de alterar identidade visual do perfil',
          'Confirme e-mail, senha e 2FA atualizados',
          'Mantenha uma frequência de publicação sustentável',
          'Use o suporte pós-venda em caso de dúvidas',
        ],
      },
      {
        heading: 'O objetivo final: autonomia sobre a página',
        paragraphs: [
          'O papel da Muita Mídia é entregar uma página verificada, com seguidores reais e transferência segura. A partir daí, o crescimento e os resultados dependem da estratégia de quem assume o perfil — e é justamente esse tempo de vantagem, ganho ao comprar uma página já formada, que faz toda a diferença.',
        ],
      },
    ],
  },
]
